const PRICEUNIT_LABELS = {
    PER_HALFHOUR: {
        default: 'Pro halber Stunde',
        short: 'pro 1/2 Std.',
    },
    PER_NIGHT_HALFHOUR: {
        default: 'Nachtparken pro halber Stunde',
    },
    PER_HOUR: {
        default: 'Pro Stunde',
        short: 'pro Std.',
    },
    PER_NIGHT_HOUR: {
        default: 'Nachtparken pro Stunde',
    },
    PER_DAY: {
        default: 'Pro Tag',
        short: 'pro Tag',
    },
    PER_NIGHT: {
        default: 'Pro Nacht',
    },
    PER_WEEKEND: {
        default: 'Pro Wochenende',
    },
    PER_WEEK: {
        default: 'Pro Woche',
    },
    PER_MONTH: {
        default: 'Pro Monat',
        short: 'pro Mt.',
    },
    PER_MONTH_NIGHT_ONLY: {
        default: 'Pro Monat, nur Nachtparken',
    },
    PER_SEASON: {
        default: 'Pro Saison',
    },
    PER_YEAR: {
        default: 'Pro Jahr',
    },
    PER_RIDE: {
        default: 'Pro Fahrt',
    },
    GASOLINE: {
        default: 'Normal',
    },
    GASOLINE_SUPER: {
        default: 'Super',
    },
    GASOLINE_SUPER_PLUS: {
        default: 'Super Plus',
    },
    GASOLINE_PREMIUM: {
        default: 'Premium Benzin',
    },
    DIESEL: {
        default: 'Diesel',
    },
    DIESEL_PREMIUM: {
        default: 'Premium Diesel',
    },
    BIODIESEL: {
        default: 'Biodiesel',
    },
    HYDROGEN: {
        default: 'Wasserstoff',
    },
    NATURAL_GAS: {
        default: 'Erdgas (CNG)',
    },
    AUTOGAS: {
        default: 'Autogas (LPG)',
    },
    ADBLUE: {
        default: 'AdBlue',
    },
    HVO100: {
        default: 'HVO 100',
    },
    UNKNOWN: {
        default: 'Andere',
    },
    ADULT: {
        default: 'Erwachsene'
    },
    CHILD: {
        default: 'Kinder'
    },
    MOTORCYCLE: {
        default: 'Motorrad'
    },
    CAR: {
        default: 'PKW'
    },
    TRUCK: {
        default: 'LKW',
    },
    PER_KWH: {
        default: 'Pro kWh'
    }
};

const PAYMENT_LABELS = {
    CASH_BAR: 'Bargeld',
    BANKOMAT: 'Bankomat',
    MAESTRO: 'Maestro',
    VISA: 'Visa',
    PARK_CREDIT_CARD: 'Parkkreditkarte',
    MASTERCARD: 'Mastercard',
    AMERICAN_EXPRESS: 'American Express',
    DINERS_CLUB: 'Diners Club',
    PARK_NET_PREMIUM: 'Parknet Premium',
    PETROL_CREDIT_CARD: 'Tankkarte',
    APP_PAYMENT: 'Apple Pay, Google Pay',
    OTHER: 'sonstiges',
    CREDIT_CARD: 'Kreditkarte',
    TICKET: 'Ticket',
    CLOCK: 'Parkuhr',
    QUICK: 'Quick',
    MACHINE: 'Automat',
    HANDY_PARKEN: 'HANDYPARKEN',
    EASY_PARK: 'EasyPark',
    PARK_NOW: 'PARK NOW',
    PARK_AND_MORE: 'Park and more',
    DIRECT_PAYMENT: 'Direktzahlung'
};

const VEHICLE_LABELS = {
    CAR: 'PKW',
    ELECTRIC_CAR: 'E-Auto',
    TRUCK: 'LKW',
    MOTORCYCLE: 'Motorrad',
    ELECTRIC_MOTORCYCLE: 'E-Motorrad',
    BUS: 'Bus',
    CAMPER: 'Wohnmobil',
    TRAILER: 'Gespann',
    // DRAWING_VEHICLE: 'Zugfahrzeug',
    BIKE: 'Fahrrad',
    ELECTRIC_BIKE: 'Elektrofahrrad',
};

const SERVICE_LABELS = {
    umbrella: 'Regenschirmverleih',
    elevator: 'Aufzug',
    washroom: 'WC',
    exchangeMachine: 'Wechselautomat',
    roofed: 'Überdacht',
    wlan: 'WLAN',
    mobileConnection: 'Mobilfunkempfang',
    video: 'Videoüberwachung',
    emergencyCall: 'Notruf',
    firedrencher: 'Feuerlöscher',
    guard: 'Portier',
    SHOP: 'Shop',
    CAR_WORKSHOP: 'Werkstatt',
    CAR_WASH: 'Waschanlage',
    changingTableAvailable: 'Wickeltisch',
    playground: 'Spielplatz',
};

const OPERATION_MODE_LABELS = {
    UNKNOWN: 'Andere',
    MACHINE: 'Automat',
    CLERK: 'Bedienung',
    SELF_SERVICE: 'Selbstbedienung'
}

const POI_TYPE_LABELS = {
    gasStations: 'Tankstelle',
    roadHouses: 'Raststation',
    ACCOMMODATION: 'Hotel',
    GASTRONOMY: 'Gastronomie',
}

const AUTH_LABELS = {
    APP: 'App',
    NFC: 'NFC',
    WEBSITE: 'Webseite',
    RFID: 'RFID',
    SMS: 'SMS',
    OTHER: 'Andere',
}

export function getPOIPriceUnitLabel(priceMode, short = false) {
    let priceUnitLabel = false;
    if (short) {
        priceUnitLabel =
            PRICEUNIT_LABELS[priceMode] && PRICEUNIT_LABELS[priceMode].short
                ? PRICEUNIT_LABELS[priceMode].short
                : false;
    } else {
        priceUnitLabel =
            PRICEUNIT_LABELS[priceMode] && PRICEUNIT_LABELS[priceMode].default
                ? PRICEUNIT_LABELS[priceMode].default
                : false;
    }

    return priceUnitLabel;
}

export function getPaymentOptionLabel(type) {
    return PAYMENT_LABELS[type] ?? false;
}

export function getVehicleLabel(type) {
    return VEHICLE_LABELS[type] ?? false;
}

export function getServiceLabel(type) {
    return SERVICE_LABELS[type] ?? false;
}

export function getOperationModeLabel(type) {
    return OPERATION_MODE_LABELS[type] ?? false;
}

export function getPoiTypeLabel(type) {
    return POI_TYPE_LABELS[type] ?? false;
}

export function getAuthOptionLabel(type) {
    return AUTH_LABELS[type] ?? false;
}